import { render, staticRenderFns } from "./news_c.vue?vue&type=template&id=7a2f6143&"
import script from "./news_c.vue?vue&type=script&lang=js&"
export * from "./news_c.vue?vue&type=script&lang=js&"
import style0 from "./news_c.vue?vue&type=style&index=0&id=7a2f6143&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports